import  Input  from './input.components'

export default Input
